import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const NewsLetter = () => {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState('');

    // On mount, try to load cached email (optional)
    useEffect(() => {
        const cachedEmail = localStorage.getItem('newsletterEmail');
        const cacheTimestamp = localStorage.getItem('newsletterEmailTimestamp');
        const now = Date.now();
        const THIRTY_MINUTES = 30 * 60 * 1000;

        if (cachedEmail && cacheTimestamp && (now - parseInt(cacheTimestamp) < THIRTY_MINUTES)) {
            setEmail(cachedEmail);
        } else {
            localStorage.removeItem('newsletterEmail');
            localStorage.removeItem('newsletterEmailTimestamp');
        }
    }, []);

    const handleChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) {
            setMessage('Please enter an email address.');
            return;
        }
        if (!/\S+@\S+\.\S+/.test(email)) {
            setMessage('Please enter a valid email address.');
            return;
        }
        setIsSubmitting(true);
        setMessage('');

        try {
            const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
            const Url = process.env.REACT_APP_API_NEWSLETTER_STORE;
            const response = await axios.post(`${apiBaseUrl}${Url}`, { email });

            if (response.status === 200) {
                toast.success('Thank you for subscribing to our newsletter!');
                localStorage.setItem('newsletterEmail', email);
                localStorage.setItem('newsletterEmailTimestamp', Date.now().toString());
                setEmail('');
            } else {
                toast.error('Something went wrong. Please try again.');
            }
        } catch (error) {
            toast.error('Something went wrong. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="footer-newsletter">
            <h6>Subscribe Our Newsletter</h6>
            <div className="newsletter-form">
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <div className="input-group mb-3">
                            <input type="email"
                                   className="form-control"
                                   value={email}
                                   onChange={handleChange}
                                   placeholder="Enter your email"
                                   aria-label="Recipient's username"
                                   aria-describedby="basic-addon2"
                                   required
                            />
                            <button className="input-group-text bg-info" type="submit" disabled={isSubmitting}>
                                {isSubmitting ? 'Submitting...' : 'Subscribe'}
                            </button>
                        </div>
                    </div>
                </form>
                {message && <p>{message}</p>}
            </div>
        </div>
    );
};

export default NewsLetter;
